export enum TransactionPropertiesGroup {
  Left,
  Returned,
}
